import cookie from 'js-cookie'
import actions from 'redux/actions'
import { reducers, getState } from 'redux/core'
import appConfig from 'app-config'
import { sentry } from 'common/helpers'


// TODO check https://developers.google.com/api-client-library/javascript/samples/samples#authorizing-and-making-authorized-requests
// TODO improve this code
// TODO looks weird but we don't handle email from scope

const _initialize = () => new Promise((resolve, reject) => {
  let timeLeft = 5 // sec

  if (window.gapi) {
    resolve()
  }
  else {
    const timer = setInterval(() => {
      if (window.gapi) {
        clearInterval(timer)
        resolve()
      }
      else if (timeLeft <= 0) {
        clearInterval(timer)
        reject()
      }
      else {
        timeLeft -= 1
      }
    }, 1000)
  }
})

const initialize = () => {
  const { models: { google: { isFetching, isInitialized, config: { clientId } } } } = getState()

  if (!isInitialized && !isFetching) {
    reducers.models.google.setFetching(true)

    return _initialize()
      .then(() => {
        window.gapi.load('client:auth2', {
          timeout: 5000,
          callback: () => {
            window.gapi.auth2.init({
              client_id: cookie.get('googleAppId') || appConfig.apiKeys.googleAppId || clientId, // TODO remove config.clientId
              scope: 'profile email',
            })
              .then(
                () => {}, // success
                (error) => {
                  // SCNT-6015
                  // maybe think of a better way to check for this error
                  if (error && error.details.startsWith('Cookies are not enabled in current environment')) {
                    reducers.models.google.setCookiesError(true)
                  }
                  else {
                    sentry.captureException(`Google Api error: ${JSON.stringify(error)}`)
                  }
                }
              )

            reducers.models.google.setFetching(false)
            reducers.models.google.setInitialized(true)
          },
          onerror: () => {
            console.error('gapi.client failed to load!')
            reducers.models.google.setFetching(false)
          },
          ontimeout: () => {
            console.error('gapi.client could not load in a timely manner!')
            reducers.models.google.setFetching(false)
          },
        })
      }, () => {
        reducers.models.google.setFetching(false)
        return Promise.reject()
      })
  }

  if (!isInitialized) {
    return Promise.reject()
  }

  return Promise.resolve()
}

const login = (isLoginGQLEnabled) =>
  initialize()
    .then(() => window.gapi.auth2.getAuthInstance().signIn())
    .then((GoogleUser) => {
      const authResponse = GoogleUser.getAuthResponse()

      return actions.models.user.googleAuth({ ...authResponse, isLoginGQLEnabled })
    })


export default {
  login,
  initialize,
}
